var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('pdf',{attrs:{"url":_vm.pdfUrl},on:{"back":function($event){return _vm.$router.back()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }